import { LoadingScreen } from "components/LoadingScreen";
import { SignIn } from "lib/auth";


export default function LoginPage() {
  return (
    <SignIn>
      <LoadingScreen title="Redirecting..." />
    </SignIn>
  )
}